// src/features/admin/router/AdminRoute.tsx
// گارد دسترسی به پنل مدیریت — فقط نقش admin
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@app/store/hooks';

export const ADMIN_ROLES = ['admin'];

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, roles } = useAppSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/Adminlogin_pass" state={{ from: location }} replace />;
  }

  const isAdmin = roles.some((role) => ADMIN_ROLES.includes(role));
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
